var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync } from 'vue-property-decorator';
import CorrectionCompanyDataModal from '@/modules/admin/components/CorrectionCompanyDataModal.vue';
import { connect } from '@/overmind';
import { NotificationService } from '@/services/NotificationService';
let CorrectionCompanyDataContainer = class CorrectionCompanyDataContainer extends Vue {
    constructor() {
        super(...arguments);
        this.companyData = {
            last_update: '',
            name: '',
            cnpj: '',
        };
        this.showCompanyResume = false;
        this.searchCompanyLoading = false;
        this.updateCompanyLoading = false;
        this.updateCompanyLinkedinOrWebsiteLoading = false;
    }
    clearStates() {
        this.companyData = {
            cnpj: '',
            last_update: '',
            name: '',
        };
        this.showCompanyResume = false;
        this.searchCompanyLoading = false;
        this.updateCompanyLoading = false;
        this.updateCompanyLinkedinOrWebsiteLoading = false;
    }
    async searchCompany(cnpj) {
        this.searchCompanyLoading = true;
        //@ts-ignore
        const result = await this.actions.searchCompany(cnpj);
        if (result) {
            this.companyData = result.data;
            this.showCompanyResume = true;
        }
        this.searchCompanyLoading = false;
    }
    async updateCompanyLinkedinOrWebsite({ cnpj, websiteUrl, linkedinUrl, }) {
        this.updateCompanyLinkedinOrWebsiteLoading = true;
        //@ts-ignore
        const result = await this.actions.updateCompanyLinkedinOrWebsite({
            cnpj,
            websiteUrl,
            linkedinUrl,
        });
        this.updateCompanyLinkedinOrWebsiteLoading = false;
        this.companyData = {
            cnpj: '',
            last_update: '',
            name: '',
        };
        if (result && result.data)
            NotificationService.success('Sucesso', 'Dados da empresa atualizada com sucesso!');
    }
    async updateCompany(cnpj) {
        this.updateCompanyLoading = true;
        //@ts-ignore
        const result = await this.actions.updateCompany(cnpj);
        this.updateCompanyLoading = false;
        if (result && result.data && result.data.success)
            NotificationService.success('Sucesso', 'A empresa foi atualizada com sucesso!');
    }
};
__decorate([
    PropSync('open', { default: false })
], CorrectionCompanyDataContainer.prototype, "show", void 0);
CorrectionCompanyDataContainer = __decorate([
    Component(connect(({ actions: { admin: actions } }) => ({
        actions: actions,
    }), {
        name: 'CorrectionCompanyDataContainer',
        components: {
            CorrectionCompanyDataModal,
        },
    }))
], CorrectionCompanyDataContainer);
export default CorrectionCompanyDataContainer;
